const cards = {
  elo: /^((6504)|(4011)|(431274)|(438935)|(45(1416|76))|(50(4175|6699|67|90[4-7]))|(63(6297|6368))|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8])|506(699|7[0-6][0-9]|77[0-8])|(509\d{3})|(504175)|(627780)|(636297)|(636368)|(65003[1-3])|(6500(3[5-9]|4[0-9]|5[0-1]))|(6505)|(6507(0[0-9]|1[0-8]))|(65072[0-7])|(6509(0[1-9]|1[0-9]|20)))/,
  mastercard: /^(5[1-5][0-9]{10}|2[0-9]{11})/,
  visa: /^4[0-9]{10}(?:[0-9]{3})/,
  diners_club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
  american_express: /^3[47][0-9]{13}/,
  hipercard: /^((606282\d{10}(\d{3})?)|(3841\d{15}))/,
  jcb: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/,
  discover:
    /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
};

export default function getCardFlagFrom(cardNumber: string) {
  const sanitizedCardNumber = cardNumber.replace(/[^0-9]/g, '');

  const flag = Object.keys(cards).find(flag => {
    const regex = cards[flag];
    return regex.test(sanitizedCardNumber);
  });

  return flag;
}
